/**
 * class-calendar.js
 * FullCalendar initialization for the class calendar page.
 * Reads event data from inline JSON rendered by class-calendar-content.liquid.
 * Adapted from the existing BTA calendar customization.
 *
 * Event JSON shape (from class-calendar-content.liquid):
 *   { title, date (YYYY-MM-DD), url, extendedProps: { startTime, endTime, ... } }
 * Times are pre-formatted text strings (e.g. "9:00", "4:30pm").
 */

(function () {
  var now = new Date();
  var todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  var classCal = {
    calendar: null,
    windowWidth: window.innerWidth,
    events: [],

    timeToMinutes: function (timeText) {
      var match = String(timeText || '').trim().toLowerCase().match(/^(\d{1,2}):([0-5]\d)\s*(am|pm)$/);
      if (!match) return null;

      var hours = parseInt(match[1], 10);
      var minutes = parseInt(match[2], 10);
      if (hours < 1 || hours > 12) return null;

      if (hours === 12) hours = 0;
      if (match[3] === 'pm') hours += 12;

      return (hours * 60) + minutes;
    },

    updateToolbar: function () {
      var calendarEl = document.getElementById('class-calendar');
      if (!calendarEl || !classCal.calendar) return;

      var isPortrait = window.innerHeight > window.innerWidth;
      var isMobile = window.innerWidth < 514;

      if (isMobile && isPortrait) {
        calendarEl.classList.add('hide-toolbar');
      } else {
        calendarEl.classList.remove('hide-toolbar');
      }
      classCal.calendar.updateSize();
    },

    init: function () {
      var dataEl = document.getElementById('class-calendar-events');
      if (!dataEl) return;

      try {
        classCal.events = JSON.parse(dataEl.textContent).map(function (e) {
          // Move url to extendedProps so FullCalendar doesn't try to
          // render <a> tags or handle click navigation internally
          if (e.url) {
            e.extendedProps = e.extendedProps || {};
            e.extendedProps.classUrl = e.url;
            delete e.url;
          }
          return e;
        });
      } catch (e) {
        console.error('Failed to parse calendar events:', e);
        classCal.events = [];
      }

      // Find the first future event date to use as initial calendar date
      var firstFutureDate = null;
      var futureDates = classCal.events
        .map(function (e) { return e.date; })
        .filter(function (d) { return d && d >= todayStart.toISOString().split('T')[0]; })
        .sort();

      if (futureDates.length > 0) {
        firstFutureDate = futureDates[0];
      }

      var calendarEl = document.getElementById('class-calendar');
      var isMobile = window.innerWidth < 514;

      var calendarOptions = {
        eventDisplay: 'block',
        displayEventTime: false,
        initialView: isMobile ? 'list' : 'dayGridMonth',
        initialDate: firstFutureDate || todayStart.toISOString().split('T')[0],
        validRange: {
          start: new Date(now.getFullYear(), now.getMonth(), 1)
        },
        contentHeight: 'auto',
        listDaySideFormat: { weekday: 'long' },
        eventOrder: function (eventA, eventB) {
          var timeA = classCal.timeToMinutes(eventA.extendedProps.startTime);
          var timeB = classCal.timeToMinutes(eventB.extendedProps.startTime);

          if (timeA === null && timeB === null) return eventA.title.localeCompare(eventB.title);
          if (timeA === null) return 1;
          if (timeB === null) return -1;
          if (timeA !== timeB) return timeA - timeB;
          return eventA.title.localeCompare(eventB.title);
        },
        eventOrderStrict: true,
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,dayGridWeek,dayGridDay,list'
        },
        views: {
          list: {
            visibleRange: function (currentDate) {
              return {
                start: currentDate,
                end: new Date(currentDate.getFullYear() + 1, 11, 31)
              };
            }
          }
        },
        loading: function (isLoading) {
          var loadingEl = document.getElementById('class-calendar-loading');
          if (loadingEl) {
            loadingEl.style.display = isLoading ? 'block' : 'none';
          }
        },
        events: classCal.events,

        eventContent: function (arg) {
          var event = arg.event;

          // Past events: use default rendering (just the title)
          if (event.start < todayStart) {
            return;
          }

          var isListView = arg.view.type.indexOf('list') !== -1;

          var html = '<div class="cc-event-content">';
          html += '<strong>' + event.title + '</strong>';

          var startTimeText = event.extendedProps.startTime;
          var endTimeText = event.extendedProps.endTime;

          if (startTimeText || endTimeText) {
            var timeDisplay = startTimeText && endTimeText
              ? startTimeText + ' - ' + endTimeText
              : (startTimeText || endTimeText);
            html += '<br>' + timeDisplay;
          }

          if (event.extendedProps.externalRegistration) {
            html += '<br><small>Register at Artisan Baking Center</small>';
          } else if (event.extendedProps.bookedOut) {
            html += '<br><small class="cc-sold-out">Sold Out</small>';
          } else if (event.extendedProps.remainingSpaces) {
            var spots = event.extendedProps.remainingSpaces;
            if (spots === 1) {
              html += '<br><small class="cc-spots-left">Only 1 spot left!</small>';
            } else if (spots <= 3) {
              html += '<br><small class="cc-spots-left">Only ' + spots + ' spots left</small>';
            } else {
              html += '<br><small class="cc-spots-left">' + spots + ' spots left</small>';
            }
          }

          // Include product image for grid views (list view images go in the graphic cell)
          if (!isListView && event.extendedProps.image) {
            html += '<div class="fc-thumb"><img src="' + event.extendedProps.image + '" loading="lazy"></div>';
          }

          html += '</div>';
          return { html: html };
        },

        eventClick: function (info) {
          var url = info.event.extendedProps.classUrl;
          if (url) {
            info.jsEvent.preventDefault();
            window.location.href = url;
          }
        },

        eventDidMount: function (info) {
          var event = info.event;
          var element = info.el;

          if (event.start < todayStart) {
            element.classList.add('past-event');
            event.setExtendedProp('classUrl', '');
          } else if (event.extendedProps.bookedOut && !event.extendedProps.externalRegistration) {
            element.classList.add('booked-out');
          }

          if (event.extendedProps.image) {
            classCal.renderImage(event, element);
          }
        },

        viewDidMount: function () {
          setTimeout(classCal.updateToolbar, 100);
        },

        windowResize: function () {
          classCal.resize();
        },

        datesSet: function (info) {
          var view = info.view;
          localStorage.setItem('__classcal.view', view.type);
          localStorage.setItem('__classcal.date', view.activeStart.toISOString());
        }
      };

      classCal.calendar = new FullCalendar.Calendar(calendarEl, calendarOptions);
      classCal.calendar.render();

      window.removeEventListener('resize', classCal.updateToolbar);
      window.removeEventListener('orientationchange', classCal.updateToolbar);

      window.addEventListener('resize', classCal.updateToolbar);
      window.addEventListener('orientationchange', function () {
        setTimeout(classCal.updateToolbar, 200);
      });

      setTimeout(classCal.updateToolbar, 100);
    },

    resize: function () {
      var newWidth = window.innerWidth;
      if (newWidth !== classCal.windowWidth) {
        classCal.calendar.changeView(newWidth < 514 ? 'list' : 'dayGridMonth');
        classCal.windowWidth = newWidth;
      }
    },

    renderImage: function (event, element) {
      var imageSrc = event.extendedProps.image;
      if (!imageSrc) return;

      // List view: replace the dot with the product image
      // (Grid view images are included in eventContent HTML)
      var listGraphic = element.querySelector('.fc-list-event-graphic');
      if (listGraphic) {
        var div = document.createElement('div');
        div.className = 'fc-thumb';
        var img = document.createElement('img');
        img.src = imageSrc;
        img.loading = 'lazy';
        listGraphic.replaceChildren();
        listGraphic.appendChild(div).appendChild(img);
      }
    }
  };

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', classCal.init);
  } else {
    classCal.init();
  }

  // Also handle bfcache (back/forward navigation)
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      classCal.init();
    }
  });
})();
